import React, { useEffect, useRef } from 'react'
import statsStore from '../../store/stats'
import { observer } from 'mobx-react-lite'


export const PositionsTableHeader = observer(() => {
  const { columns, initialGridTemplate } = statsStore
  const remSize = 10

  const headRef = useRef(null)

  useEffect(() => {
    if(!headRef.current) return;
    const containerFullWidth = headRef.current.getBoundingClientRect().width
    statsStore.calculateInitialWidth(containerFullWidth)
  }, [headRef.current])

  const resizingRef = useRef({
    index: null,
    startX: 0,
    startWidth: 0,
    isResizing: false,
  })

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { isResizing, index, startX, startWidth } = resizingRef.current
      if (!isResizing || e.buttons !== 1) return
      const deltaX = e.clientX - startX
      const deltaRem = deltaX / remSize
      const newWidths = [...initialGridTemplate]
      newWidths[index] = Math.max(5, startWidth + deltaRem)
      statsStore.updateGridTemplate(newWidths)
    }

    const handleMouseUp = () => {
      resizingRef.current = {
        index: null,
        startX: 0,
        startWidth: 0,
        isResizing: false,
      }
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [initialGridTemplate])

  const handleMouseDown = (e, index) => {
    resizingRef.current = {
      index,
      startX: e.clientX,
      startWidth: initialGridTemplate[index],
      isResizing: true,
    }
  }

  const headerCellsRender = columns.map(({ id, title }, index) => {
    const isNotLastCell = index < columns.length - 1
    return (
      <div key={id}
           className={`relative flex items-center ${isNotLastCell ? 'border-r border-gray-200' : ''} bg-[#FFFFFF] py-[2.2rem] px-[1.3rem]`}
           style={{ minWidth: 0 }}
      >
        <span className="overflow-hidden overflow-ellipsis text-Regular(12_14) text-Content/Dark font-semibold">{title}</span>
        {isNotLastCell && (
          <div onMouseDown={e => handleMouseDown(e, index)}
            className="absolute top-0 right-0 h-full w-1.5 cursor-col-resize z-10"
          />
        )}
      </div>
    )})

  return (
    <div className="grid w-full mt-[8px] bg-[#FFFFFF]" ref={headRef} style={{
      gridTemplateColumns: initialGridTemplate.map(w => `${w}rem`).
        join(' ')
    }}>
      {headerCellsRender}
    </div>
  )
})